<template>
  <div :class="[`group-58-4-1`, className || ``]">
    <div class="rectangle-46-3"></div>
    <div class="rectangle-47-3"></div>
    <div class="rectangle-48-3"></div>
  </div>
</template>

<script>
export default {
  name: "Group582",
  props: ["className"],
};
</script>

<style>
.group-58-4-1 {
  display: flex;
  gap: 1.1px;
  height: 8px;
  left: 5px;
  position: absolute;
  top: 7px;
  width: 7px;
}

.rectangle-46-3 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 3.88px;
  margin-left: 0;
  margin-top: 3.9px;
  width: 1.66px;
}

.rectangle-47-3 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 5.82px;
  margin-top: 1.9px;
  width: 1.66px;
}

.rectangle-48-3 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 7.76px;
  margin-top: 0;
  width: 1.66px;
}
</style>
